/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.6.0",
  "gitBuildTime": "2026-05-14T16:20:24.558Z",
  "gitBuildVersion": "1.6.0",
  "gitCommitId": "035ea3f",
  "gitCommitIdFull": "035ea3f16f014bba1b21d04b050e977fc52a156f",
  "gitCommitTime": "2026-05-14T16:18:23.000Z",
  "version": "1.6.0-2026-05-14T16:18:23.000Z-(035ea3f)"
};
